module.exports = __webpack_public_path__ + "img/cooperative0_logo12.64b60511.jpg";